import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const useCountryApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    addCountry: builder.mutation({
      query: ({ body }) => ({
        url: '/account/admin/dicts/countries/',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили новую страну', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    editCountry: builder.mutation({
      query: ({ id, body }) => ({
        url: `/account/admin/dicts/countries/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили страну', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    deleteCountry: builder.mutation({
      query: ({ id }) => ({
        url: `/account/admin/dicts/countries/${id}`,
        method: 'DELETE',
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили страну', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useAddCountryMutation, useEditCountryMutation, useDeleteCountryMutation } = useCountryApi;
